import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, SnackbarContent, Slide } from '@material-ui/core';

import { RootState } from 'src/configs/store';
import './Toast.scss';
import Icon from '../Icon/Icon';
import _ from 'lodash';

function Transition(props) {
  return <Slide { ...props } direction="left" />;
}

function Toast() {
  const { type, display, message } = useSelector((state: RootState) => state.toast);
  const dispatch = useDispatch();

  const closeToast = () => {
    dispatch.toast.changeDisplay();
  };

  const checkMessage = () => {
    if (message && message.includes('\n')){
      const newMessage = message.split('\n');
      return (_.map(newMessage, (m) => {
        return (<span>{ m } <br /></span>);
      }))
      ;
    }
    return  message;
  };

  return (
    <Snackbar
      anchorOrigin={ { vertical: 'top', horizontal: 'right' } }
      open={ display }
      autoHideDuration={ 10000 }
      onClose={ closeToast }
      onClick={ closeToast }
      TransitionComponent={ Transition }
    >
      <SnackbarContent
        className={ `toast ${ type }` }
        message={
          <div className="toast__container">
            <div className="toast__icon">
              { <Icon icon={ type } /> }
            </div>
            <div className="toast__content">
              <div className="toast__message">
                { checkMessage() }
              </div>
            </div>
          </div>
        }
      />
    </Snackbar>
  );
}

export default Toast;
